<template>
  <div
    class="nav-bar z-index-max"
    :class="[{ 'iphonex-top': isIphoneX }, { 'bottom-line': pageName }]"
    :style="navBarStyle"
  >
    <div class="left">
      <!-- 定制具名插槽 -->
      <slot name="nav-left"></slot>
    </div>
    <div class="right">
      <!-- 定制具名插槽 -->
      <slot name="nav-right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 是否展示默认状态
    isDefault: {
      default: true,
      type: Boolean
    },
    // 是否展示默认后退按钮
    isShowBack: {
      default: true,
      type: Boolean
    },
    // 默认状态下页面标题的名称
    pageName: {
      default: "",
      type: String
    },
    // navBar样式
    navBarStyle: {
      type: Object,
      default: function() {
        return {
          backgroundColor: "white"
          
        };
      }
    }
  },
  data: function() {
    return {
      isIphoneX: window.isIphoneX
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@css/style.scss";
.nav-bar {
  width: 100%;
  // height: $navBarHeight;
  // line-height: $navBarHeight;
   height: 1.3rem;
  line-height: 1.3rem;
  display: flex;
  justify-content: space-between;
  // 适配手机 stateBar
  // padding-top: $stateBarHeight;
  
background: linear-gradient(0deg, #269CA8 0%, #6AC6BA 100%);
  .left{
    display: flex;
    height: 100%;
    width: 200px;
   
  }
  .right {
    display: flex;
    height: 100%;
    flex:1;

  }
}

.bottom-line {
  border-bottom: 1px solid $lineColor;
}
</style>
